import { render, staticRenderFns } from "./RecuperarSenhaForm.vue?vue&type=template&id=13baa0d5&scoped=true"
import script from "./RecuperarSenhaForm.vue?vue&type=script&lang=js"
export * from "./RecuperarSenhaForm.vue?vue&type=script&lang=js"
import style0 from "./RecuperarSenhaForm.vue?vue&type=style&index=0&id=13baa0d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13baa0d5",
  null
  
)

export default component.exports